import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ExtendedProjectInfoDc, ProjectConfigurationDc } from "@evergis/api";

import { useProjectInfo } from "../../ducks/project/hooks";

// Todo remove the type after api update
type ExtendedProjectInfoDc2 = ExtendedProjectInfoDc & { content: ProjectConfigurationDc & { language: string } };

export const useProjectSettings = () => {
  const { i18n } = useTranslation();
  const [project] = useProjectInfo() as unknown as [ExtendedProjectInfoDc2];

  useEffect(() => {
    if (project?.content?.language && project.content.language !== i18n.language) {
      i18n.changeLanguage(project.content.language);
    }
  }, [project?.content?.language]);
};
